import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggingService } from '../../shared/services/logging';
import { select, Store } from '@ngrx/store';
import * as fromUserSetting from '../../user-setting/store';
import {
    combineLatest,
    Observable,
    ReplaySubject,
    BehaviorSubject
} from 'rxjs';
import {
    filter,
    map,
    switchMap,
    takeWhile,
    takeUntil,
    tap
} from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import * as UserSettingActions from '../../user-setting/store/user-setting.actions';
import * as fromUserInfo from '../../user-info';
import * as fromAuth from '../../auth/store';
import * as fromRoot from '../../store';
import * as fromSettings from '../../company-setting';
import { AuthenticationService } from '../../auth/authentication.service';

@Component({
    selector: 'ef-chat-feature',
    templateUrl: './chat-feature.component.html',
    styleUrls: ['./chat-feature.component.scss'],
    standalone: false
})
export class ChatFeatureComponent implements OnInit {
    private active = true;

    constructor() {}

    ngOnInit(): void {

    }
}
